import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {BannerType, EventsFilter} from './interfaces';
import PromoPage from './FrontPage/PromoPage';
import PageView from './PageView/PageView';
import Banner from './common/Banner';
import {mediaQuery, getFilterFromPath} from '../helpers';
import {useHistory, useLocation, useParams} from 'react-router-dom';
import {setAllFilters, toggleModal, toggleModalType} from '../redux/actions'
import {RootState} from '../redux/reducers';
import {MainFooter} from './common/footer'
import Maintenance from './FrontPage/maintenance';

type FrontPageProps = {
    filters: EventsFilter,
    banners: { banners: BannerType[]} | null,
    isLoggedIn?: { loggedIn: boolean}
    from?: string | null
}
const FrontPage = (props: FrontPageProps) => {
    const { isLoggedIn, from } = props;
    // @ts-ignore
    const {filters, banners} = useSelector((state: RootState) => state)
    const location = useLocation();
    useEffect(() => {
        if (location.pathname !== '/events') {
            const effectFilters = getFilterFromPath(location.pathname);
            if (effectFilters.kind !== filters.kind || effectFilters.where !== filters.where || filters.date !== effectFilters.date) {
                if (filterEmpty()) {
                    dispatch(setAllFilters(effectFilters))
                }
            }
        }
    },[location, filters])

    const filterEmpty = (): boolean => {
        return !filters.where && !filters.date && !filters.kind && !filters.keyword
    }
    // @ts-ignore
    let showModalWindow = useSelector((state: RootState) => state.showModalWindow)

    const collectFrontBanners = (): BannerType[] | [] => {
        let filteredBanners:BannerType[] = [];
        if (banners && banners.banners && banners.banners.length) {
            let type = '_desktop';
            if (mediaQuery('(max-width: 411px)')) {
                type = '_mobile';
            }
            filteredBanners = banners.banners.filter((banner:BannerType) => banner.placement === 'top_big' && banner.type === type)
        }
        return filteredBanners;
    }

    const frontBanner = collectFrontBanners();
    // @ts-ignore
    const {token} = useParams();
    const dispatch = useDispatch();
    const history = useHistory();

    if (isLoggedIn && isLoggedIn.loggedIn) {
        if (token && !showModalWindow) {
            dispatch(toggleModalType('changepassword'));
            dispatch(toggleModal());
        }
    } else {
        if (token) {
            // console.log('TOKEN:', token)
            history.push('/');
        }
    }
    return (

        <React.Fragment>

            {filterEmpty() ?
                <React.Fragment>
                    <div className='pb-main'>
                        <Banner banners={frontBanner}/>
                        <PromoPage />
                        {/*<PiletiLeviTop />*/}
                        {/*<LatestEvents />*/}
                        
                        {/* <Maintenance /> */}
                        <MainFooter />
                    </div>
                </React.Fragment>
                :
                <React.Fragment>
                    <PageView />
                    <Banner banners={frontBanner}/>
                </React.Fragment>
            }

        </React.Fragment>
    )
}

export default FrontPage
